import blog1 from  '../img/blogs/blog5.svg';
import blog2 from '../img/blogs/blog4.svg'

const blogs = [
    {
        id: 1,
        title: 'Getting started with Cypress',
        date: '11',
        month: 'February',
        image: blog1,
        link: 'https://dev.to/sultanparvez/getting-started-with-cypress-4p05'
    },
    {
        id: 2,
        title: 'Selector strategies',
        date: '10',
        month: 'March',
        image: blog2,
        link: 'https://dev.to/sultanparvez/selector-strategies-3bce'
    }
]

export default blogs;